import Vue from 'vue';
import Vuex from 'vuex';
import createMutationsSharer, {
  BroadcastChannelStrategy,
  LocalStorageStratery,
} from 'vuex-shared-mutations';

import authenticationModule from './modules/authentication';
import overviewStepsModule from './modules/overviewSteps';
import adTrackingModule from './modules/adTracking';
import versioningModule from './modules/versioning';
import advisorCodeModule from './modules/advisorCode';
import assistanceGuideModule from './modules/assistanceGuide';
import tebaEmailPopupModule from './modules/tebaEmailPopup';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: authenticationModule,
    overviewSteps: overviewStepsModule,
    versioning: versioningModule,
    adTracking: adTrackingModule,
    advisorCode: advisorCodeModule,
    assistanceGuide: assistanceGuideModule,
    tebaEmailPopup: tebaEmailPopupModule,
  },
  plugins: [
    createMutationsSharer({
      strategy: BroadcastChannelStrategy.available()
        ? new BroadcastChannelStrategy()
        : new LocalStorageStratery(),
      predicate: [
        'authSuccess',
        'logout',
        'loginAs',
        'setNumberOfCompletedSteps',
        'setVersion',
        'setNewVersionAvailable',
        'coBrandingUrl',
        'setOmtId',
        'setAdReferrer',
        'setFullReferrer',
        'setHasSeenPopupSinceLogin',
        'setHasSeenTebaEmailPopupSinceLogin',
        'setPendingRedirect',
      ],
    }),
  ],
});
